var _defs, _circle, _path, _path2, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPizzaGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Pizza marker gold",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pizza Marker Gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pizzaGoldGlow",
    cx: 32,
    cy: 44,
    r: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fef08a",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#facc15",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#facc15",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 44,
    r: 24,
    fill: "url(#pizzaGoldGlow)",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18 Q32 6 52 18 L32 60 Z",
    fill: "#fef08a",
    stroke: "#b45309",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22 Q32 12 48 22 L32 55 Z",
    fill: "#fde68a",
    stroke: "#f59e0b",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 30,
    r: 5,
    fill: "#facc15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 4,
    fill: "#facc15"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 42,
    r: 5,
    fill: "#facc15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPizzaGold);
export default __webpack_public_path__ + "static/media/marker-pizza-gold.88435d07b5d4e7ab07ba77d3b18617a5.svg";
export { ForwardRef as ReactComponent };